import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { notFoundRoutes } from 'app/not-found/routes/not-found-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(notFoundRoutes)
  ],
  exports: [ RouterModule ]
})
export class NotFoundRoutingModule { }
